var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Loading from '../Loading/Loading';
export default function FreeButton(_a) {
    var loading = _a.loading, onClick = _a.onClick, className = _a.className, children = _a.children, props = __rest(_a, ["loading", "onClick", "className", "children"]);
    function clickHandler(e) {
        if (onClick && !loading) {
            onClick(e);
        }
    }
    return (_jsx("button", __assign({}, props, { className: 'button FreeButton ' + className, onClick: clickHandler }, { children: loading ? _jsx(Loading, {}, void 0) : children }), void 0));
}
//# sourceMappingURL=FreeButton.js.map